// هشدار دائمی مدارک ارائه‌دهندگان در میز کار و نوبت‌دهی (AC-IAM-022.3، AP-IAM-05): مدرک منقضی یا رو به انقضا (≤ ۳۰ روز) و مدرک الزامی
// ثبت‌نشده؛ ارائه‌دهنده غیرفعال نمی‌شود (BR-IAM-022). فقط با iam.provider.credential_alert.view.
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { unwrap } from '@phoenix/api-client';
import { useAccess, useTenantSession } from '@phoenix/auth';
import { useTranslation } from '@phoenix/i18n';
import { toJalali } from '@phoenix/ui';
import { useQuery } from '@tanstack/react-query';
import { credentialKeys } from './ProviderCredentialsSection';

export function CredentialAlertsBanner({ providerId }: { providerId?: string | null }) {
  const { t } = useTranslation('iam');
  const { tenantApi, session } = useTenantSession();
  const access = useAccess();
  const permitted = access.can('iam.provider.credential_alert.view');
  const alerts = useQuery({
    queryKey: [...credentialKeys.alerts(session?.tenantId), providerId ?? 'all'],
    queryFn: () =>
      unwrap(tenantApi.GET('/api/v1/identity/providers/credential-alerts', { params: { query: { providerId: providerId ?? undefined } } })),
    enabled: permitted,
    staleTime: 5 * 60_000,
  });
  const items = alerts.data?.items ?? [];
  if (!permitted || items.length === 0) {
    return null;
  }
  const expired = items.some((item) => item.state !== 'Expiring');
  return (
    <Alert severity={expired ? 'error' : 'warning'} data-testid="credential-alerts">
      <AlertTitle>{t('iam:credential.alerts_title')}</AlertTitle>
      {items.slice(0, 5).map((item) => (
        <div key={`${item.providerId}-${item.type}-${item.credentialId ?? 'missing'}`}>
          {t(`iam:credential.alert.${item.state}`, {
            provider: item.providerName,
            type: t(`iam:credential.types.${item.type}`),
            date: item.expiresOn ? toJalali(item.expiresOn) : '',
          })}
        </div>
      ))}
      {items.length > 5 ? t('iam:credential.alerts_more', { count: items.length - 5 }) : null}
    </Alert>
  );
}
